import { PostWeb } from '@nucleus/types/web/posts/post';
import { PostIndexDocumentWeb } from '@nucleus/web-hosting';
import React from 'react';
import { formatPostDate } from '../lib/post';

interface Props {
  post?: PostWeb | PostIndexDocumentWeb;
  relative?: boolean;
}

/**
 * Renders a Post's date as 'MMMM d, yyyy', or optionally as relative time ago
 */
export const PostDate = ({ post, relative }: Props): JSX.Element | null => {
  if (post === undefined) {
    return null;
  }

  return <>{formatPostDate(post, relative)}</>;
};

